import { Clock } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export function History() {
  return (
    <>
      <Helmet>
        <title>History | Aker Stadium - From 1998 to Today</title>
        <meta 
          name="description" 
          content="Explore the rich history of Aker Stadium from its opening in 1998 to today's modern arena. Read about key moments, modernizations, and developments through the years."
        />
      </Helmet>
      <div className="min-h-screen bg-gray-100">
        <div className="bg-[#2173B9] text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-4">
              <Clock className="w-8 h-8" />
              <h1 className="text-3xl font-bold">History</h1>
            </div>
            <p className="text-lg opacity-90">
              From the opening in 1998 to today's modern arena
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img
                src="/images/molde-1.jpg"
                alt="Aker Stadium at Opening"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <h2 className="text-2xl font-bold mb-4">Opening of Aker Stadium</h2>
                <p className="text-gray-600">
                  Aker Stadium was officially opened in 1998 and has since been the home ground of Molde FK. 
                  The stadium was built by the fjord and has evolved into a modern arena with capacity for 
                  over 11,000 spectators. This development has made it possible to offer both players and fans 
                  a unique experience on match days.
                </p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <img
                src="/images/molde-5.jpg"
                alt="Aker Stadium Modern View"
                className="w-full h-64 object-cover rounded-lg mb-4"
              />
              <h2 className="text-2xl font-bold mb-4">Modernization and Development</h2>
              <p className="text-gray-600 mb-6">
                Aker Stadium features facilities such as modern stands, changing rooms, and VIP areas, 
                which have made the stadium a competitive venue in Norwegian football.
              </p>
              
              <h3 className="text-xl font-bold mb-3">Important Matches and Events</h3>
              <p className="text-gray-600 mb-6">
                Aker Stadium has hosted many memorable matches, from intense local derbies 
                to important Norwegian Cup fixtures and European cup matches. Molde FK has experienced 
                both triumphs and challenges on this ground, contributing to the stadium's place 
                in Norwegian football history.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-2xl font-bold mb-4">Cultural Events</h2>
              <p className="text-gray-600">
                In addition to football, Aker Stadium has also been used for other cultural 
                events, including concerts and festivals. This has made the stadium an important 
                gathering place for the entire Molde region, where both football and culture are celebrated.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-2xl font-bold mb-4">Stadium's Future</h2>
              <p className="text-gray-600">
                Molde FK has ambitious plans to further develop Aker Stadium for the future. 
                This includes additional modernizations to ensure a safe and comfortable 
                experience for spectators while preserving the stadium's rich history.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
